module.exports = __webpack_public_path__ + "static/media/Formular-Regular.48b65460.otf";